import { Link, useLocation, useParams } from "react-router-dom";
import WithLayout from "../../components/Layout/Layout";
import LocalNews from "../../components/HomeComp/LocalNewsHomeComp";
import TopStoriesDetailsCom from "../../components/HomeComp/TopStoriesDetailsCom/TopStoriesDetailsCom";
import { useEffect, useState } from "react";
import TopStoriesDetailsMobileCom from "../../components/HomeComp/TopStoriesDetailsCom/TopStoriesDetailsMobileCom";
import moment from "moment";
import CategoryPolls from "../../components/CategoryPolls/CategoryPolls";
import SecHead from "../../components/SectionHeader/SecHead";
import { useDispatch, useSelector } from "react-redux";
import {
  filterpost,
  getCatagoryDetail,
  getPublicLatestPost,
} from "../../redux/actions/publicAction";
import Tranding from "../trending/Trending";
import LatestNewsBottom from "../../components/commonComponenets/LatestNewsBottom";
import { formatBreadcrumbName } from "../../helpers/utilities";

function TopStorydetailsId() {
  const { id, slug } = useParams();
  const location = useLocation();
  // console.log("id123", id, slug);

  // const breadcumbpath=pathSegments.pop()

  // console.log("id",id);
  const dispatch = useDispatch();

  const [isMobile, setIsMobile] = useState(
    window.matchMedia("(max-width: 768px)").matches
  );

  const isVerified = localStorage.getItem("accessToken");

  const {
    publicPostDetails,
    menuList,
    navbarlistid,
    latestPost,
    getbacktodetails,
  } = useSelector((state) => state.publicReducer);

  // console.log("getbacktodetails", getbacktodetails);

  const { tranding } = useSelector((state) => state.privateReducer);
  useEffect(() => {
    dispatch(getPublicLatestPost(3));
    // dispatch();
  }, []);
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.matchMedia("(max-width: 768px)").matches);
    };
    window.scrollTo(0, 0);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // bradcumb
  const pathSegments = location.pathname.split("/").filter(Boolean);
  // pathSegments.pop();
  const breadCumb = [
    { id: 1, name: isVerified ? "For You" : "News", link: "/" },
    ...pathSegments.map((segment, index) => {
      // Construct link for each segment
      const link = `/${pathSegments.slice(0, index + 1).join("")}`;
      // console.log("link", link);

      return { id: index + 2, name: formatBreadcrumbName(segment), link };
    }),
  ];

  const createSlug = (title) =>
    title
      .toLowerCase()
      .replace(/\s+/g, "-")
      .replace(/[^\w-]+/g, "");
  function cleanString(str) {
    // console.log("stttta",str.replace(/[^a-zA-Z0-9-_]/g, ""));

    return str.replace(/[^a-zA-Z0-9-_]/g, "");
  }
  return (
    <>
      <div className="bg_home  bg-[#F7F8FA] md:px-40 flex flex-col pb-14">
        <div className="flex-[2] ">
          {isMobile ? (
            <div className="flex flex-col  gap-5 ">
              <div className=" flex flex-col ">
                <TopStoriesDetailsMobileCom postDetailsid={slug} />
              </div>
            </div>
          ) : (
            <>
              <div className="py-4">
                {breadCumb?.map((item, index) => (
                  <span
                    key={item.id}
                    className={`text-[10px] font-medium  ${
                      index === breadCumb.length - 1 ? "" : "opacity-60"
                    }`}
                  >
                    {/* {console.log("breadCumb , ", breadCumb)} */}
                    {index > 0 && " > "}
                    {index < breadCumb?.length - 1 ? (
                      <Link to={item?.link} className="breadcrumb-link">
                        {item?.name}
                      </Link>
                    ) : (
                      <>{item?.name}</>
                    )}
                  </span>
                ))}
              </div>
              <div className="flex min-[1040px]:flex-row flex-col gap-5 mb-5 ">
                {/* <div className="flex flex-col gap-5"> */}
                <div className="flex-[2] flex flex-col gap-5 min-[1040px]:w-3/5">
                  <TopStoriesDetailsCom postDetailsid={slug} />
                </div>
                <div className="flex-1 flex flex-col gap-5">
                  <div className="bg-white w-full p-3 md:p-0 rounded-lg sticky top-[3rem]">
                    <LocalNews />
                  </div>
                </div>
                {/* </div> */}
              </div>
            </>
          )}
          {/* latest post common componenet */}
          <LatestNewsBottom />
        </div>
      </div>
    </>
  );
}
TopStorydetailsId.Layout = WithLayout;
export default TopStorydetailsId;
